import LegalShell, { Section } from "@/components/LegalShell";

export default function TermsPage() {
  return (
    <LegalShell
      testid="terms-page"
      eyebrow="legal · terms of service"
      title="Terms of Service"
      lastUpdated="2026-05-18"
    >
      <Section heading="1. Introduction">
        <p>
          Welcome to <strong className="text-zinc-200">The Founder Mode Quest</strong>,
          an AI-powered Socratic learning platform operated by{" "}
          <strong className="text-zinc-200">Super Founder Hub</strong> (&ldquo;we&rdquo;,
          &ldquo;us&rdquo;, &ldquo;our&rdquo;). By creating an account, paying for, or
          accessing any quest on this platform, you (&ldquo;user&rdquo;,
          &ldquo;you&rdquo;) agree to be bound by these Terms of Service.
        </p>
      </Section>

      <Section heading="2. Eligibility">
        <p>
          You must be at least <strong className="text-zinc-200">18 years of age</strong>{" "}
          to use this service. By using the platform, you represent that you meet this
          requirement. The service is not intended for, and may not be used by, minors.
        </p>
      </Section>

      <Section heading="3. Service description">
        <p>
          The Founder Mode Quest is a digital learning platform comprising{" "}
          <strong className="text-zinc-200">13 AI-powered quests</strong> built on the
          book <em>The Founder Mode: Escape 9 to 5, Find Problem-Solution Fit & Scale
          to $10 Million in 3 Years</em> by Praveen Singh V. Each quest is a Socratic
          dialogue with an AI mentor that challenges your thinking, scores your
          responses across five founder dimensions (clarity, problem-solution fit,
          empathy, growth, execution), and produces a personalized roadmap.
        </p>
        <p>
          Quests 0 and 1 are free forever. Quests 2 through 12 require a one-time
          purchase of the Founder Pass (see Payment section).
        </p>
      </Section>

      <Section heading="4. Account and email">
        <p>
          The platform uses passwordless authentication: you log in with your email
          and a chosen display name. You are responsible for keeping your email
          account secure. We do not store passwords. We do not use cookies or browser
          local storage; session state is held in memory while the browser tab is open.
        </p>
      </Section>

      <Section heading="5. Payment">
        <p>
          The Founder Pass is a <strong className="text-zinc-200">one-time payment</strong>{" "}
          that unlocks lifetime access to all 13 quests, the monthly leaderboard, and
          Gold/Silver/Bronze monthly awards.
        </p>
        <ul className="list-disc pl-6 space-y-1 marker:text-amber-400">
          <li>India: ₹4,997 via Razorpay</li>
          <li>International: $197 USD via Stripe</li>
        </ul>
        <p>
          Prices are inclusive of applicable taxes where required. We do not store
          credit card or bank details on our servers — all payment processing happens
          at the gateway (Razorpay or Stripe) under their PCI-DSS compliant infrastructure.
        </p>
      </Section>

      <Section heading="6. License">
        <p>
          Upon successful payment, we grant you a{" "}
          <strong className="text-zinc-200">personal, non-transferable,
          non-exclusive license</strong> to access and use the platform for your own
          founder education. You may not resell, redistribute, sublicense, or share
          your account with others. Each Founder Pass is for one person.
        </p>
      </Section>

      <Section heading="7. Prohibited conduct">
        <ul className="list-disc pl-6 space-y-1 marker:text-amber-400">
          <li>Sharing account access with others</li>
          <li>Attempting to extract, scrape, or reverse-engineer the AI prompts</li>
          <li>Submitting illegal, defamatory, or harmful content to the AI</li>
          <li>Attempting to disrupt the service or other users</li>
          <li>Using the platform to violate any applicable law</li>
        </ul>
        <p>
          We reserve the right to suspend or terminate accounts that violate these
          rules, without refund.
        </p>
      </Section>

      <Section heading="8. Intellectual property">
        <p>
          The book content distilled into the quests is © Praveen Singh V. The
          platform, software, AI prompts, scoring rubrics, and visual design are ©
          Super Founder Hub. All rights reserved. Your conversation transcripts with
          the AI mentor are yours; you may export them on request.
        </p>
      </Section>

      <Section heading="9. AI disclaimers">
        <p>
          The AI mentor uses OpenAI&apos;s GPT-4o model to generate Socratic questions
          and scores. AI output is{" "}
          <strong className="text-zinc-200">educational guidance only</strong> and
          should not be treated as financial, legal, tax, investment, or professional
          advice. You are responsible for your own business decisions.
        </p>
      </Section>

      <Section heading="10. Termination">
        <p>
          You may stop using the service at any time. We may suspend or terminate
          your access if you violate these Terms or engage in fraudulent activity.
          See our Refund Policy for refund eligibility.
        </p>
      </Section>

      <Section heading="11. Limitation of liability">
        <p>
          To the maximum extent permitted by law, Super Founder Hub and its founders
          shall not be liable for indirect, incidental, special, consequential, or
          punitive damages arising out of your use of the platform. Our aggregate
          liability is limited to the amount you paid for the Founder Pass.
        </p>
      </Section>

      <Section heading="12. Governing law">
        <p>
          These Terms are governed by the laws of India. Any disputes arising out of
          or in connection with these Terms shall be subject to the exclusive
          jurisdiction of the courts of <strong className="text-zinc-200">Bangalore,
          Karnataka, India</strong>.
        </p>
      </Section>

      <Section heading="13. Contact">
        <p>
          Questions about these Terms? Reach us at:
        </p>
        <ul className="list-none pl-0 space-y-1 text-zinc-300">
          <li>Email: <a href="mailto:praveen@thefoundermode.in" className="text-amber-300 hover:text-amber-200">praveen@thefoundermode.in</a></li>
          <li>Phone: +91 94483 10439</li>
          <li>Address: Super Founder Hub, Kanapura Main Road, Bangalore, Karnataka, India</li>
        </ul>
      </Section>
    </LegalShell>
  );
}
